export default {
  data: function() {
    return {
      language: this.$store.getters.language,
      supportedLanguages: this.$store.getters.supportedLanguages
    }
  },
  computed: {
    menu: function() {
      let aboutUsLabel = 'About QSDS'
      let aboutUsLink = '/about-us'
      let servicesLabel = 'Services'
      let servicesLink = '/services'
      let adviceAndSupportLabel = 'Advice and support'
      let adviceAndSupportLink = '/advice-and-support'

      const languageValue = this.language.value
      switch (languageValue) {
        case 'nl': {
          aboutUsLabel = 'Over QSDS'
          aboutUsLink = '/over-ons'
          servicesLabel = 'Diensten'
          servicesLink = '/diensten'
          adviceAndSupportLabel = 'Advies en ondersteuning'
          adviceAndSupportLink = '/advies-en-ondersteuning'
        }
        default: {
          aboutUsLink = '/' + languageValue + aboutUsLink
          servicesLink = '/' + languageValue + servicesLink
          adviceAndSupportLink = '/' + languageValue + adviceAndSupportLink
        }
      }

      return [
        {
          label: aboutUsLabel,
          link: aboutUsLink
        },
        {
          label: servicesLabel,
          link: servicesLink
        },
        {
          label: adviceAndSupportLabel,
          link: adviceAndSupportLink
        }
      ]
    },
    contact: function() {
      let label = 'Contact'
      let name = 'QSDS'
      let city = 'BE - 9140 TEMSE'
      let email = 'info@qsds.be'

      return {
        label: label,
        name: name,
        city: city,
        email: email
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/Footer/Footer.js